import React, { useState } from 'react';
import { useLanguageLocale } from '../../../../../hooks/language-locale-hooks';
import { GenericToolbar } from '../../../../../components/GenericToolbar';
import { pushAppRoute } from '../../../../../data/domain/route-manager';
import { useSelectedSiteData, isRecordFound } from '../../../../../hooks/data-hooks';
import { useHistory } from 'react-router-dom';
import { ContentContainer } from '../../../../../components/ContentContainer';
import { RecordDataIndicators } from '../../../../../components/RecordDataIndicators';
import { TimelineEvents } from '../../../../../components/TimelineEvents';
import { useAppRoute } from '../../../../../hooks/app-route-hooks';
import { Icon } from '../../../../../lib/icons';
import { ExportPopUp } from '../../../../../components/ExportPopUp/ExportPopUp';
import { useSelector } from 'react-redux';
import { Selectors } from '../../../../../selectors';
import { IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as Colors from '@brightlayer-ui/colors';
import { ToolbarColor } from '../../../../../components/GenericToolbar/GenericToolbar';
import { useSignalRSiteData } from '../../../../../data/DataProviders/SignalRSiteDataProvider';

const useStyles = makeStyles({
    downloadWhite: { color: Colors.white[50] },
    downloadDefault: { background: '#ffffff00' },
});
export const OverviewSiteTimeline: React.FC = () => {
    const { t } = useLanguageLocale();
    const classes = useStyles();
    const selectedSiteData = useSelectedSiteData();
    const exportLoading = useSelector(Selectors.TimelineExport.timelineExportLoading);
    const currentAppRoute = useAppRoute('OverviewSiteTimeline');
    const history = useHistory();
    const realTimeSiteData = useSignalRSiteData();

    const [open, setOpen] = React.useState(false);
    const [alarm, setAlarm] = useState(false);
    const onClose = (): void => setOpen(false);
    const hasAlarm =
        isRecordFound(selectedSiteData) && selectedSiteData.value.alarmCount && selectedSiteData.value.alarmCount > 0
            ? true
            : false;

    React.useEffect(() => {
        setAlarm(hasAlarm);
        if (realTimeSiteData && realTimeSiteData.alarmStatus && realTimeSiteData.alarmStatus.length > 0)
            setAlarm(realTimeSiteData.alarmCount > 0);
    }, [realTimeSiteData, hasAlarm]);

    return <>
        <GenericToolbar
            showBackButton
            backButtonOnClick={(): void => {
                pushAppRoute(history, {
                    type: 'OverviewSite',
                    locationId: currentAppRoute.locationId,
                    siteId: currentAppRoute.siteId,
                });
            }}
            color={alarm ? ToolbarColor.Error : ToolbarColor.Default}
            title={t('DASHBOARD.TIMELINE_DETAILS.TIMELINE')}
            subtitle={isRecordFound(selectedSiteData) ? selectedSiteData.value.name : ''}
            customIcon={
                <>
                    <IconButton
                        disabled={exportLoading}
                        data-testid="siteSummary-download"
                        style={{ margin: 10, cursor: 'pointer' }}
                        onClick={(): void => setOpen(true)}
                        size="large">
                        <Icon.GetApp className={alarm ? classes.downloadWhite : classes.downloadDefault} />
                    </IconButton>
                </>
            }
        />

        <ContentContainer testId="site-details-timeline-page">
            <RecordDataIndicators
                recordData={selectedSiteData}
                errorMessage={t('DASHBOARD.ERROR_LOADING_SITE')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.SITE_NOT_FOUND')}
            />

            {isRecordFound(selectedSiteData) && (
                <>
                    <TimelineEvents
                        appRoute={{
                            type: 'OverviewSiteTimelineEventDetails',
                            locationId: currentAppRoute.locationId,
                            siteId: currentAppRoute.siteId,
                            alarmId: '--',
                            deviceId: '--',
                        }}
                    />
                    {open && (
                        <ExportPopUp
                            for="Site"
                            open={open}
                            onClose={onClose}
                            siteDetails={selectedSiteData.value}
                        ></ExportPopUp>
                    )}
                </>
            )}
        </ContentContainer>
    </>;
};
